export const ConnectionDirection = {
    None: 'none',
    Forward: 'forward',
    Backward: 'backward',
    Bidirectional: 'bidirectional'
};

export const ConnectionStyle = {
    Solid: 'solid',
    Dashed: 'dashed',
    Dotted: 'dotted'
};

export const Connections = {
    None: 'none',
    Parallel: 'parallel',
    Serial: 'serial',
    Branch: 'branch'
};

export const Shapes = {
    Device: 'device',
    Line: 'line',
    Virtual: 'virtual',
    Computer: 'computer',
    Router: 'router',
    Cloud: 'cloud'
};
